export default "__VITE_ASSET__BhUFOblT__"